import React, {Component, Fragment} from "react";
import {withPixiApp} from "@inlet/react-pixi";
import withMenuConfiguration from "./configuration/withMenuConfiguration";
import * as PIXI from "pixi.js";

import {connect} from "react-redux";
import {IStore} from "../../store/IStore";
import {Dispatch} from "redux";

import { Button} from "react-bootstrap";

import {MDBBtn, MDBCol, MDBContainer, MDBIcon, MDBRow, MDBTable, MDBTableBody} from "mdbreact";

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import "react-toggle/style.css"
import {isMobile} from "react-device-detect";
import {actions as buttonActions} from "../../reducers/buttonPanelReducer";
import {actions as menuActions} from "../../reducers/menuReducer";
import {actions as soundActions} from "../../reducers/soundReducer";



interface IProps {
    [x: string]: any;

}

interface IState {

}

interface IState {
    isGameLoaded: boolean,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    buttonSelected: any,

}

interface IStateToProps {

}

interface IDispatchToProps {

}

class Menu extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected autoplayContainer: any;
    protected scope: any;
    protected showFixedPanelPage: boolean;
    protected outerBorderColor: any;
    protected textColor: any;
    protected mainContainerBgColor: any;
    protected insideContainerBgColor: any;
    protected borderColorOfInsideContainer: any;

    constructor(props: IProps) {
        super(props);

        this.app = props.app;
        this.autoplayContainer = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            pixelRatio: 1,
            isGameLoaded: false,
            buttonSelected: "",
        }
        this.showFixedPanelPage = false
        this.outerBorderColor = '#ffffff'
        this.textColor = '#f5f3ec'
        this.mainContainerBgColor = '#000000'
        this.insideContainerBgColor = '#232222'
        this.borderColorOfInsideContainer = '#808080'

    }

    reset() {
        this.setState((prevState) => {
            return {
                ...prevState,


            }
        })
    }

    onClick(name: any, value: any) {

        this.setState((prevState) => {
            return {
                ...prevState,
                // selectedautoplayCount: value,
                buttonSelected: name,
                // enableOk: true,

            }
        })

    }


    updateDimensions = () => {

        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })


    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    onMouseClick = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }

    mobileViewMenu() {
        return (
            <MDBTable height={"200px"}>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td colSpan={4}
                            style={{border: "none", borderBottom: '1px solid' + this.borderColorOfInsideContainer}}>
                            <MDBContainer style={{padding: '0px', margin: '0px'}}>
                                <MDBRow center={true}>
                                    <h2 style={{
                                        color: this.textColor,
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                    }}>{this.props.langObj["menuText_5"]}</h2>
                                </MDBRow>
                                <MDBRow center={true}>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b1" ? "green" : "grey"} name={"b1"}
                                                onClick={() => this.onClick("b1", 0.01)}>
                                            {this.props.langObj["menuText_8"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b2" ? "green" : "grey"} name={"b2"}
                                                onClick={() => this.onClick("b2", 0.05)}>
                                            {this.props.langObj["menuText_9"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b3" ? "green" : "grey"} name={"b3"}
                                                onClick={() => this.onClick("b3", 0.07)}>
                                            {this.props.langObj["menuText_10"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b4" ? "green" : "grey"} name={"b4"}
                                                onClick={() => this.onClick("b4", 0.1)}>
                                            {this.props.langObj["menuText_11"]}
                                        </MDBBtn>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b5" ? "green" : "grey"} name={"b5"}
                                                onClick={() => this.onClick("b5", 0.5)}>
                                            {this.props.langObj["menuText_12"]}
                                        </MDBBtn>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow center={true} style={{marginTop: '10px'}}>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b6" ? "green" : "grey"} name={"b6"}
                                                onClick={() => this.onClick("b6", 0.7)}>
                                            {this.props.langObj["menuText_13"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b7" ? "green" : "grey"} name={"b7"}
                                                onClick={() => this.onClick("b7", 1)}>
                                            {this.props.langObj["menuText_14"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b8" ? "green" : "grey"} name={"b8"}
                                                onClick={() => this.onClick("b8", 2)}>
                                            {this.props.langObj["menuText_15"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b9" ? "green" : "grey"} name={"b9"}
                                                onClick={() => this.onClick("b9", 5)}>
                                            {this.props.langObj["autoplayText_9"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '20%',
                                        maxWidth: '20%',
                                        padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b10" ? "green" : "grey"}
                                                name={"b10"}
                                                onClick={() => this.onClick("b10", 10)}>
                                            {this.props.langObj["autoplayText_10"]}
                                        </MDBBtn>
                                    </MDBCol>

                                </MDBRow>
                            </MDBContainer>
                        </td>

                    </tr>
                </MDBTableBody>
            </MDBTable>
        )
    }

    desktopViewMenu() {
        return (

            <MDBTable style={{marginTop: '5%', width: '60%', marginLeft: '15%'}}>
                <MDBTableBody>
                    <tr>
                        <td style={{
                            border: 'none',
                            transform: "scale(" + this.props.scaleY + ")",
                            transformOrigin: 'center'
                        }}>
                            <MDBContainer style={{
                                height: '80%',
                                width: '80%',
                                position: 'absolute',
                                left: '16%',
                                top: '10%',
                                // backgroundColor: this.mainContainerBgColor,
                            }}>
                                <MDBRow style={{border: '4px solid' + this.outerBorderColor, borderBottom: 'none'}}>
                                    <MDBCol size="12" sm="12" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        height: '88px'
                                    }}>
                                        <h2 style={{
                                            position: 'relative',
                                            top: '17%',
                                            color: this.textColor,
                                            fontSize: '23px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                        }}>{this.props.langObj["mobViewPanel_Text_1"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow style={{
                                    backgroundColor: this.mainContainerBgColor,
                                    border: '4px solid' + this.outerBorderColor,
                                    borderTop: 'none'
                                }}>
                                    <MDBCol style={{height: '470px'}}>
                                        <MDBTable style={{
                                            backgroundColor: this.insideContainerBgColor,
                                            border: '1px solid' + this.borderColorOfInsideContainer,
                                            height: '350px'
                                        }}>
                                            <MDBTableBody>
                                                <tr>
                                                    <td>
                                                        <MDBRow>
                                                            <MDBCol size="12" sm="12" style={{
                                                                backgroundColor: this.insideContainerBgColor,
                                                                border: 'none',
                                                                height: '61px'
                                                            }}>
                                                                <h2 style={{
                                                                    // position: 'relative', top: '17%',
                                                                    color: this.textColor,
                                                                    fontSize: '23px',
                                                                    textAlign: 'center',
                                                                    fontWeight: 'bold',
                                                                }}>{this.props.langObj["menuText_6"]}</h2>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                            <MDBTableBody style={{border: 'none'}}>
                                                <tr>
                                                    <td style={{border: 'none'}}>
                                                        <MDBContainer>
                                                            <MDBRow>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b1" ? "green" : "grey"}
                                                                            name={"b1"}
                                                                            onClick={() => this.onClick("b1", 0.01)}>
                                                                        {this.props.langObj["menuText_8"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b2" ? "green" : "grey"}
                                                                            name={"b2"}
                                                                            onClick={() => this.onClick("b2", 0.05)}>
                                                                        {this.props.langObj["menuText_9"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b3" ? "green" : "grey"}
                                                                            name={"b3"}
                                                                            onClick={() => this.onClick("b3", 0.07)}>
                                                                        {this.props.langObj["menuText_10"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b4" ? "green" : "grey"}
                                                                            name={"b4"}
                                                                            onClick={() => this.onClick("b4", 0.1)}>
                                                                        {this.props.langObj["menuText_11"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b5" ? "green" : "grey"}
                                                                            name={"b5"}
                                                                            onClick={() => this.onClick("b5", 0.5)}>
                                                                        {this.props.langObj["menuText_12"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                            <MDBTableBody style={{border: 'none'}}>
                                                <tr>
                                                    <td style={{border: 'none'}}>
                                                        <MDBContainer>
                                                            <MDBRow>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b6" ? "green" : "grey"}
                                                                            name={"b6"}
                                                                            onClick={() => this.onClick("b6", 0.7)}>
                                                                        {this.props.langObj["menuText_13"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b7" ? "green" : "grey"}
                                                                            name={"b7"}
                                                                            onClick={() => this.onClick("b7", 1)}>
                                                                        {this.props.langObj["menuText_14"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b8" ? "green" : "grey"}
                                                                            name={"b8"}
                                                                            onClick={() => this.onClick("b8", 2)}>
                                                                        {this.props.langObj["menuText_15"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b9" ? "green" : "grey"}
                                                                            name={"b9"}
                                                                            onClick={() => this.onClick("b9", 5)}>
                                                                        {this.props.langObj["autoplayText_9"]}

                                                                    </MDBBtn>
                                                                </MDBCol>
                                                                <MDBCol size="3" sm="3" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    width: '20%',
                                                                    maxWidth: '20%',
                                                                    padding: '0px'
                                                                }}>
                                                                    <MDBBtn style={{
                                                                        width: '70px',
                                                                        height: '50px',
                                                                        padding: '0px',
                                                                        margin: '0px'
                                                                    }}
                                                                            color={this.state.buttonSelected == "b10" ? "green" : "grey"}
                                                                            name={"b10"}
                                                                            onClick={() => this.onClick("b10", 10)}>
                                                                        {this.props.langObj["autoplayText_10"]}
                                                                    </MDBBtn>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                            <MDBTableBody style={{border: 'none'}}>
                                                <tr>
                                                    <td style={{border: 'none'}}>
                                                        <MDBContainer>
                                                            <MDBRow style={{height: '80px'}}>
                                                                <MDBCol size="6" sm="6" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    textAlign: 'right'
                                                                }}>
                                                                    <Button variant="danger"
                                                                            style={{borderRadius: '25px'}}
                                                                            onClick={() => {
                                                                                this.props.setAllButtonEnable();
                                                                                this.props.hideMenuUI();
                                                                            }}>Cancel</Button>
                                                                </MDBCol>
                                                                <MDBCol size="6" sm="6" style={{
                                                                    backgroundColor: this.insideContainerBgColor,
                                                                    border: 'none',
                                                                    textAlign: 'left'
                                                                }}>

                                                                    <Button variant="success"
                                                                            style={{borderRadius: '25px'}}
                                                                            onClick={() => {
                                                                                this.props.setAllButtonEnable();
                                                                                this.props.hideAutoplay();
                                                                                // this.props.setAutoplay(selectedautoplayCount);
                                                                                // this.props.setApplicationAutoplayCount(selectedautoplayCount);
                                                                                this.props.startAutoplay();
                                                                                this.props.getApplicationSpinResponse();
                                                                                this.props.setAllButtonDisable();
                                                                                this.reset();
                                                                            }}>{this.props.langObj["menuText_7"]}</Button>{' '}
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </MDBContainer>
                                                    </td>
                                                </tr>
                                            </MDBTableBody>
                                        </MDBTable>
                                    </MDBCol>
                                </MDBRow>

                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>

            </MDBTable>
        )
    }

    render() {
        if (!this.props.showMenu) {
            return (<></>)
        }
        if (isMobile) {
            this.showFixedPanelPage = true
        }
        return (
            <div>
                {!this.showFixedPanelPage && <div>
                    {this.desktopViewMenu()}
                </div>}
                {this.showFixedPanelPage && <div>
                    {this.mobileViewMenu()}
                </div>}
            </div>
        )
    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'menuState' | 'soundState' | 'applicationState'>): IStateToProps =>
        ({
            showMenu: state.menuState.showMenu,
            allSoundBGMStop: state.soundState.allSoundBGMStop,
            allSoundSFXStop: state.soundState.allSoundSFXStop,
            scaleY: state.applicationState.scaleY,

        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideMenuUI: (): any => dispatch(menuActions.hideMenuUI()),
        stopAllBGMSound: (stopAllBgSound: boolean): any => dispatch(soundActions.stopAllBGMSound(stopAllBgSound)),
        stopAllSFXSound: (stopAllSfxSound: boolean): any => dispatch(soundActions.stopAllSFXSound(stopAllSfxSound)),


    }))(withMenuConfiguration(Menu)));